import type { JSX } from "react";

import Grid from "@mui/material/Grid";
import {
  ThumbnailControlProps,
  useThumbnailControlLayoutProps,
  useVisibleAttributeValues,
} from "@plansoft-configuration-renderer/components";
import { CsValueController } from "@plansoft-configuration-renderer/framework";

import { ThumbnailItem } from "./ThumbnailItem";

/**
 * Thumbnail control
 * @category UI
 * @param props
 * @returns
 */
export function CustomThumbnailControl(
  props: ThumbnailControlProps,
): JSX.Element {
  const values = useVisibleAttributeValues();

  const { gridSpacing, gridDirection } = useThumbnailControlLayoutProps();

  return (
    <Grid container direction={gridDirection} spacing={gridSpacing}>
      {values.map((value) => (
        <Grid key={value.id} size="auto">
          <CsValueController value={value}>
            <ThumbnailItem>{props.children}</ThumbnailItem>
          </CsValueController>
        </Grid>
      ))}
    </Grid>
  );
}
